import { render, staticRenderFns } from "./ActInfo.vue?vue&type=template&id=f50ce4fc&scoped=true"
import script from "./ActInfo.vue?vue&type=script&lang=js"
export * from "./ActInfo.vue?vue&type=script&lang=js"
import style0 from "./ActInfo.vue?vue&type=style&index=0&id=f50ce4fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50ce4fc",
  null
  
)

export default component.exports